import { CountUp } from 'countup.js';
import { Controller } from "@hotwired/stimulus";

/** Pull first numeric token; keep prefix/suffix for CountUp display. */
function parseCountUpSpec(raw) {
    const s = String(raw ?? "").trim();
    const m = s.match(/^(.*?)(\d[\d,]*(?:\.\d+)?)(.*)$/s);
    if (!m) return null;
    const [, prefix, numStr, suffix] = m;
    const endVal = parseFloat(numStr.replace(/,/g, ""));
    if (Number.isNaN(endVal)) return null;
    const dec = numStr.match(/\.(\d+)/);
    const decimalPlaces = dec ? dec[1].length : 0;
    return { endVal, prefix, suffix, decimalPlaces };
}

export default class extends Controller {
    static values = {
        value: String,
    };

    connect() {
        const parsed = parseCountUpSpec(this.valueValue);
        if (!parsed) return;

        const { endVal, prefix, suffix, decimalPlaces } = parsed;
        const counter = new CountUp(this.element, endVal, {
            autoAnimate: true,
            prefix,
            suffix,
            ...(decimalPlaces > 0 ? { decimalPlaces } : {}),
        });
        if (!counter.error) {
            counter.start();
        }
    }
}
